import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import Skeleton from './Skeleton';

/**
 * AppointmentCardSkeleton - Loading placeholder for appointment cards
 * 
 * Layout:
 * - Date/time column (left)
 * - Divider
 * - Therapist info column (right)
 * - Status badge
 * 
 * Use this when loading appointments list
 * 
 * @version 1.0.0 (Feb 2026)
 */

const AppointmentCardSkeleton = () => {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'grey.200',
        mb: 2,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" gap={3}>
          {/* Date/Time column */}
          <Box sx={{ minWidth: 100 }}>
            <Skeleton
              variant="text"
              width={80}
              height={24}
              animation="wave"
              sx={{ mb: 1 }}
            />
            <Skeleton
              variant="text"
              width={60}
              height={20}
              animation="wave"
            />
          </Box>

          {/* Divider */}
          <Box
            sx={{
              width: 1,
              bgcolor: 'grey.300',
              mx: 2,
            }}
          />

          {/* Therapist info */}
          <Box flex={1}>
            <Box display="flex" gap={2} alignItems="center">
              <Skeleton
                variant="circular"
                width={48}
                height={48}
                animation="wave"
              />
              <Box flex={1}>
                <Skeleton
                  variant="text"
                  width="60%"
                  height={20}
                  animation="wave"
                  sx={{ mb: 0.5 }}
                />
                <Skeleton
                  variant="text"
                  width="40%"
                  height={16}
                  animation="wave"
                />
              </Box>
              <Skeleton
                variant="rectangular"
                width={80}
                height={24}
                animation="wave"
                sx={{ borderRadius: '12px' }}
              />
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AppointmentCardSkeleton;
